// extracted by mini-css-extract-plugin
module.exports = {"NewClip":"NewClip_NewClip__3z9n2","hidden":"NewClip_hidden__2yAbq"};